import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { getStorage, setStorage } from "../services/localStorageService";

import "react-tabs/style/react-tabs.css";
import "./layout.css";
import useModuleTracker from "../hooks/Track/useModuleTracker";
import moment from "moment";
import AccountExpiryNotifyModal from "../components/modals/AccountExpiryNotifyModal";
import TaskManagerRequest from "../services/TaskManagerRequest";

const Default = (props) => {
  const showSidebar = useSelector((state) => state.groupReducer.showSidebar);

  var date = moment().format("YYYY-MM-DD");
  const [isAlert, setIsAlert] = useState(false);
  const [accountExpiryModal, setAccountExpiryModal] = useState(false);

  const accountExpiry = getStorage("accountExpiry", "object") || null;
  const user = getStorage("__user__", "object");
  const sessionToken = getStorage("__sessionToken__", "string") || null;

  // TRACK
  const moduleTimes = useModuleTracker();
  useEffect(() => {}, [moduleTimes]);

  useEffect(() => {
    const isShown = getStorage(`isAlertShown_${date}`);
    if (isShown != "true") {
      // FOR SHO, ENABLE ITS
      // setIsAlert(true);
    } else {
      setIsAlert(false);
    }
  }, []);

  useEffect(() => {
    if (!accountExpiry) return;

    const { expiryDiff, trialDiff, isPastAllowedDate, allowedDate } =
      accountExpiry;

    const msInDay = 1000 * 60 * 60 * 24;
    const allowedDaysLeft = Math.ceil(
      (new Date(allowedDate) - new Date()) / msInDay
    );

    if (
      !isPastAllowedDate &&
      // case 1: both expired → check allowed days
      ((expiryDiff < 0 && trialDiff < 0 && allowedDaysLeft < 30) ||
        // case 2a: nearing expiry (within 30 days and still active)
        (expiryDiff > 0 && expiryDiff <= 30) ||
        // case 2b: trial ending (within 14 days and active) but only if already expired
        (trialDiff > 0 && trialDiff <= 14 && expiryDiff < 0))
    ) {
      setAccountExpiryModal({
        show: true,
        message: { ...accountExpiry, allowedDaysLeft },
      });
    }
  }, [accountExpiry?.username]);

  const checkSession = async () => {
    try {
      // will send 401 if session expired and will redirect to login page from task manager reqeust
      const response = await TaskManagerRequest(
        "/beta/user/session-check",
        { userId: user?.id },
        false,
        false,
        false,
        sessionToken
      );
      if (response && response?.sessionToken) {
        setStorage("__sessionToken__", response?.sessionToken);
      }
    } catch (error) {
      console.log("Error in checking password session :: ", error);
    }
  };

  useEffect(() => {
    checkSession();
  }, [user?.id, sessionToken]);

  const handleCloseAccountExpiryModal = () => {
    setAccountExpiryModal({ show: false, message: {} });
    localStorage.removeItem("accountExpiry");
  };

  return (
    <>
      <AccountExpiryNotifyModal
        show={accountExpiryModal?.show}
        message={accountExpiryModal?.message}
        closeModal={handleCloseAccountExpiryModal}
      />
      {isAlert ? (
        <div
          class="alert alert-danger alert-dismissible fade show text-white"
          role="alert"
          style={{ position: "absolute", zIndex: 1, width: "100%" }}
        >
          Lorem ipsum dolor sit amet consectetur adipisicing elit. A nesciunt
          accusamus maiores rerum
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
            onClick={() => {
              setIsAlert(false);
              setStorage(`isAlertShown_${date}`, "true");
            }}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      ) : (
        <></>
      )}

      <div className="as-main-container">
        <div className="as-header">
          <Header />
        </div>

        <div
          className={`as-body-conten ${
            !showSidebar ? "as-body-content-no-sidebar" : ""
          }`}
        >
          {/* SIDEBAR  */}
          {showSidebar && <Sidebar />}

          {/* MAIN  */}
          <div
            className={
              showSidebar
                ? "as-body-data"
                : "as-body-data w-100 no-right-border"
            }
          >
            {props.children}
          </div>
        </div>
      </div>
    </>

    // <section >
    //    <Header />
    //    {showSidebar && <Sidebar />}
    //    <main className={`main-content mt-1 border-radius-lg ${isReportMap ? 'move-to-left' : ''}`}>
    //       {/* move-to-left */}
    //       <div className={props.max100  == false  ? 'container-fluid container-fluid-app' : 'container-fluid container-fluid-app max100' }  >
    //          {props.children}
    //       </div>

    //    </main>
    // </section >
  );
};

export default Default;
